import {
  DownloadReportResponse,
  Options,
  ReportFormat,
  ReportsResponse,
  Resource
} from 'services/api';

import Company from './Company.service';

export default class Report extends Company {
  private static instance: Report;

  private constructor(options: Options) {
    /* istanbul ignore next */
    super(options);
  }

  /**
   * This return the singleton instance of the class
   * @param {Options} options
   */
  public static getInstance(options: Options) {
    if (!this.instance) {
      this.instance = new this(options);
    }

    return this.instance;
  }

  /**
   * Get a list of company order reports
   */
  list(params?: Record<string, any>) {
    return this.getEntities<ReportsResponse>(Resource.Reports, params);
  }

  /**
   * Download a company's order reports
   * params.has('format') must be TRUE
   * params.get('format') must be of type ReportFormat
   */
  download(params: Record<string, any>) {
    const url = `${this.buildUrl(Resource.Reports)}`;

    return this.makeRequest<DownloadReportResponse>({
      url,
      method: this._request.Get,
      params,
      responseType:
        params.get('format') == ReportFormat.xlsx ? 'arraybuffer' : 'text'
    });
  }
}
